
// run express js
export const domainWeb = 'https://hinano-admin-api.herokuapp.com'
//export const domainWeb = 'http://localhost:3000'
//export const domainWeb = 'http://34.128.93.153:3000'